import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { money, shortDate } from "@/lib/format";
import { UsersThree, Buildings } from "@phosphor-icons/react";

export default function AdminOrgs() {
  const { data: users } = useQuery({ queryKey: ["admin-users"], queryFn: async () => (await api.get("/admin/users")).data });
  const { data: orgs } = useQuery({ queryKey: ["admin-orgs"], queryFn: async () => (await api.get("/admin/organizations")).data });

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Organizations & Users</h1>
        <p className="mt-1 text-sm text-muted-foreground">Multi-tenant hierarchy: Owner → Reseller → Organization → User.</p>
      </div>

      <section className="space-y-3">
        <h2 className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground"><Buildings size={15} weight="bold" className="text-primary" /> Organizations ({orgs?.organizations?.length || 0})</h2>
        <div className="grid gap-3 md:grid-cols-3">
          {(orgs?.organizations || []).map((o) => (
            <div key={o.id} className="rounded-lg border border-white/10 bg-card p-4">
              <p className="font-medium">{o.name}</p>
              <p className="text-xs text-muted-foreground">{o.type} · {o.owner_email}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground"><UsersThree size={15} weight="bold" className="text-primary" /> Users ({users?.users?.length || 0})</h2>
        <div className="overflow-hidden rounded-lg border border-white/10 bg-card">
          <div className="grid grid-cols-12 gap-2 border-b border-white/10 px-4 py-3 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
            <div className="col-span-3">Name</div>
            <div className="col-span-4">Email</div>
            <div className="col-span-2">Role</div>
            <div className="col-span-2 text-right">Wallet</div>
            <div className="col-span-1 text-right">Status</div>
          </div>
          {(users?.users || []).map((u) => (
            <div key={u.id} data-testid={`user-row-${u.id}`} className="grid grid-cols-12 items-center gap-2 border-b border-white/5 px-4 py-3 text-sm last:border-0">
              <div className="col-span-3 truncate">{u.name}</div>
              <div className="col-span-4 truncate text-muted-foreground">{u.email}</div>
              <div className="col-span-2"><span className="rounded-full bg-primary/15 px-2 py-0.5 text-[10px] font-semibold text-primary">{u.role}</span></div>
              <div className="col-span-2 text-right font-mono-metric font-semibold">{money(u.wallet_balance_cents)}</div>
              <div className="col-span-1 text-right text-[10px] text-emerald-400">{u.status}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
